<template>
	<div class="hidden">
		<div class="col">
			<p>下载Excel模板：
				<a :href="docCourseApi.down"><el-button type="text">模板文件</el-button></a>
			</p>
			<p>Excel格式如下：</p>
			<el-table border
			    :data="tableData"
			    style="width: 500px">
			    <!-- <el-table-column
			      type="index"
			      :index="indexMethod">
			    </el-table-column> -->
			    <el-table-column
			      prop="phone"
			      label="手机号"
			      min-width="100%">
			    </el-table-column>
				 <el-table-column
			      prop="isPay"
			      label="是否付费"
			      min-width="100%">
			    </el-table-column>
				 <el-table-column
			      prop="channel"
			      label="渠道"
			      min-width="100%">
			    </el-table-column>
				 <el-table-column
			      prop="endTime"
			      label="结束时间"
			      min-width="100%">
			    </el-table-column>
			</el-table>
			<el-upload
				ref='upload'
				:headers='commonUrl.headers'
				:before-upload='beforeUpload'
				:on-success='onSuccess'
				:data='data'
			  	:action="docCourseApi.excelList">
					<el-button type="success" plain size='medium'
					 style='margin: 10px 0;'>
						选择Excel文件
					</el-button>
			</el-upload>
			<p>选择渠道规则：</p>
			<p>1. YZ代表有赞、XET代表小鹅通、BB代表呗呗平台、不填写代表其他...</p>
		</div>
		<el-card class="col">
			<p>总共 {{total}} 位学员</p>
			<p>导入成功 {{success}} 位</p>
			<p>导入失败 {{error}} 位<span v-if='error!=0'>，分别是：</span></p>
			<p v-if='error!=0'>
				<template v-for='(item, index) in errorList'>
					<span :key="index">{{item.userPhone}}({{item.message}})</span>
				</template>
			</p>
		</el-card>
	</div>
</template>
<script scoped>
	import docCourseApi from '@/api/contentManage/docCourseManage'
	import commonApi from '@/api/common'
	export default{
		name: 'excelMember',
		data() {
      		return {
      			docCourseApi: docCourseApi,
      			commonUrl: commonApi.commonUrl,
      			tableData: [{
      				phone: '13100011111',
					isPay: '是',
					channel: 'YZ',
					endTime: '2024-09-03 23:59:59'
      			},{
      				phone: '13100011112',
					isPay:'是',
					channel: 'YZ',
					endTime: '2025-10-03 00:59:59'
      			}],
      			success: 0,
      			error: 0,
      			total: 0,
      			errorList: [],
      			data: {}
      		}
      	},
      	props: {
      		courseId: String,
  			userType: String
      	},
      	watch: {
      		courseId() {
      			this.data = {
      				courseId: this.courseId,
      				userType: 2
      			}
      			this.init()
      		}
      	},
      	mounted() {
  			this.data = {
  				courseId: this.courseId,
  				userType: 2
  			}      		
      	},
      	methods: {
      		init() {
      			this.success = 0
      			this.error = 0
      			this.total = 0
      			this.errorList = []
      			this.$refs.upload.clearFiles()
      		},
      		indexMethod(index) {
		    	return index+1;
	      	},
	      	// 上传限制
		    beforeUpload(file) {
				console.log(file);
		        var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)                 
		        const extension = testmsg === 'xls'  
		        const extension2 = testmsg === 'xlsx'
		        if(extension2||extension) {
		        	this.$message.info('上传中，请稍后...')
		        	return true
		        }  
	            this.$message.error('上传文件格式错误!');
	            return false
		    },
		    onSuccess(res) {
				res = this.$apiOldResDeal(res)
		    	if(res.Success){
		    		this.success = res.Data.successNum
		    		this.total = res.Data.totalNum
		    		this.error = res.Data.failNum
		    		this.errorList = res.Data.failMessages
		    		if(res.Data.successNum){
		    			this.$message.success('操作成功, 请刷新列表查看！')
		    		}
		    	}else{
		    		this.$message.error(res.Msg)
		    	}
		    }
		    /*upload() {
        		// this.$refs.upload.submit();
      		},*/
      	}
	};
</script>

<style type="text/less" lang="less" scoped>
	.col{
		width: 45%;
		float: left;
		margin-left: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/views/contentManage/docCourseManage/excelMember.vue